import { columnSummaryMapper } from 'common/utils/utils';
import { RELEASES_MODEL, RELEASES_TABLE_MODEL } from '../Releases.model';

const useCols = ({ releases, withIncidentsCount }) => {
  const cols = [
    {
      dataPoint: RELEASES_TABLE_MODEL.NAME_CELL,
      name: 'RELEASES',
      summary: RELEASES_MODEL.SUMMARY.RELEASES
    },
    {
      dataPoint: RELEASES_TABLE_MODEL.COMMIT_SHA_CELL,
      name: (
        <>
          REFERENCE <br /> (sha / branch / tag)
        </>
      ),
      nameForDataCy: 'REFERENCE'
    },
    {
      dataPoint: RELEASES_TABLE_MODEL.REPOSITORY_CELL,
      name: 'REPOSITORIES',
      summary: RELEASES_MODEL.SUMMARY.REPOSITORIES
    },
    {
      dataPoint: RELEASES_TABLE_MODEL.PUBLISHED_AT_CELL,
      name: 'PUBLISHED AT',
      isSortedCol: true,
      sortPoint: RELEASES_MODEL.PUBLISHED_AT
    },
    {
      dataPoint: RELEASES_TABLE_MODEL.STAGE_CELL,
      name: 'STAGE'
    },
    {
      dataPoint: RELEASES_TABLE_MODEL.CONNECTED_BRANCHES_CELL,
      name: (
        <>
          CONNECTED
          <br />
          BRANCHES
        </>
      ),
      nameForDataCy: 'CONNECTED BRANCHES'
    },
    ...(withIncidentsCount
      ? [
          {
            dataPoint: RELEASES_TABLE_MODEL.INCIDENTS,
            name: 'INCIDENTS'
          }
        ]
      : []),
    {
      dataPoint: RELEASES_TABLE_MODEL.SERVICES_CELL,
      name: 'SERVICES'
    },
    {
      dataPoint: RELEASES_TABLE_MODEL.RELEASE_DETECTION_CELL,
      name: (
        <>
          RELEASE
          <br />
          DETECTION
        </>
      ),
      nameForDataCy: 'RELEASE DETECTION'
    }
  ];
  return cols.map(col => columnSummaryMapper(col, releases));
};

export default useCols;
